import { gql } from 'apollo-angular';

import { PAYMENT_INVOICE_OBJECT } from '../../../../@graphql/operations/fragment';

export const GET_CALCULATED_PORTFOLIO_DATA = gql`
  query getCalculatedPortfolioData(
    $year: Int
    $id_user: Int
    $company: String
    $id_seller: Int
    $id_customer: Int
    $country_iso: String
  ) {
    getCalculatedPortfolioData(
      year: $year
      id_user: $id_user
      company: $company
      id_seller: $id_seller
      id_customer: $id_customer
      country_iso: $country_iso
    ) {
      dataTable {
        code
        customer
        seller
        total
        daysPastDue
        DSO
        BPDSO
        ADD
        details {
          invoice
          invoice_number
          electronic_number
          dueDate
          createdDate
          total
          totalPaid
          cancelledDate
          daysBetweenDates
          participation
          daysPastDue
          daysWeighted
          participationByItem
          paid {
            ...PayInvoiceObject
          }
          creditNote {
            fact
            code
            total
          }
          debitNote {
            fact
            code
            total
          }
        }
      }
      totals {
        total
        totalADD
        totalDSO
        totalBPDSO
      }
      showTable
    }
  }
  ${PAYMENT_INVOICE_OBJECT}
`;
